import { render, staticRenderFns } from "./auth-redirect.vue?vue&type=template&id=de6522de"
import script from "./auth-redirect.vue?vue&type=script&lang=js"
export * from "./auth-redirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\fenxijunya-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de6522de')) {
      api.createRecord('de6522de', component.options)
    } else {
      api.reload('de6522de', component.options)
    }
    module.hot.accept("./auth-redirect.vue?vue&type=template&id=de6522de", function () {
      api.rerender('de6522de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/auth-redirect.vue"
export default component.exports